import React from "react";
import ErrorMessage from './ErrorMessage'
import { useState } from 'react';

export default ({ show, text }) => {
    const [hidden, setHidden] = useState(false)

    return (
        <ErrorMessage
            show={!hidden && show}
            text={text}
            onClickClose={() => setHidden(true)}
        />
    )
}